/**
 * FoxKit Quantity Breaks Badge Repositioner
 * Version: 1.3.1
 * Platform: Shopify (FoxKit Sales Boost)
 */
(function() {
    // Initialize required styles for transition handling
    const styles = document.createElement('style');
    styles.textContent = `
        .f-quantity-breaks__popular-badge {
            opacity: 0;
            transition: opacity 0.2s ease-out;
        }
        .f-quantity-breaks__popular-badge.is-positioned {
            opacity: 1;
        }
    `;
    document.head.appendChild(styles);

    const SELECTORS = {
        container: 'foxkit-quantity-breaks',
        highlightedChoice: '.f-quantity-breaks__choice--highlighted',
        popularBadge: '.f-quantity-breaks__popular-badge',
        choiceInner: '.f-quantity-breaks__choice-inner',
        choiceInfo: '.f-quantity-breaks__choice-info'
    };

    function movePopularBadge() {
        const components = document.querySelectorAll(SELECTORS.container);
        
        components.forEach(quantityBreaksComponent => {
            const targetChoice = quantityBreaksComponent.querySelector(SELECTORS.highlightedChoice);
            if (!targetChoice) return;

            const popularBadge = targetChoice.querySelector(SELECTORS.popularBadge);
            if (!popularBadge) return;

            const label = targetChoice.querySelector(SELECTORS.choiceInner);
            const firstElement = label?.querySelector(SELECTORS.choiceInfo);
            if (!label || !firstElement) return;

            if (!label.querySelector(':scope > ' + SELECTORS.popularBadge)) {
                requestAnimationFrame(() => {
                    label.insertBefore(popularBadge, firstElement);
                    // Add positioned class after DOM update
                    setTimeout(() => popularBadge.classList.add('is-positioned'), 50);
                });
            }
        });
    }

    function initializeObserver() {
        const observer = new MutationObserver(() => {
            requestAnimationFrame(movePopularBadge);
        });

        const target = document.querySelector(SELECTORS.container)?.parentElement || document.body;
        observer.observe(target, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        movePopularBadge();
    }

    // Initialize with immediate execution
    if (document.querySelector(SELECTORS.container)) {
        requestAnimationFrame(initializeObserver);
    } else {
        const observer = new MutationObserver((mutations, obs) => {
            if (document.querySelector(SELECTORS.container)) {
                obs.disconnect();
                requestAnimationFrame(initializeObserver);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();























// Función que maneja la visibilidad de los elementos details en el footer
function handleDetailsVisibility() {
 // Selecciona todos los elementos details dentro del footer usando las clases BEM
 const details = document.querySelectorAll('.c-custom-footer__links .c-custom-footer__group details');
 
 // Determina si estamos en desktop (viewport >= 768px)
 const isDesktop = window.innerWidth >= 768;

 // Itera sobre cada elemento details
 details.forEach(detail => {
   if (isDesktop) {
     // En desktop: agrega el atributo open para mostrar el contenido 
     detail.setAttribute('open', '');
   } else {
     // En mobile: remueve el atributo open para permitir el comportamiento acordeón
     detail.removeAttribute('open');
   }
 });
}

// Función debounce para optimizar el evento resize
// Previene múltiples ejecuciones durante el redimensionamiento
function debounce(func, wait) {
 let timeout;
 
 return function executedFunction(...args) {
   const later = () => {
     clearTimeout(timeout);
     func(...args);
   };
   
   clearTimeout(timeout);
   timeout = setTimeout(later, wait);
 };
}

// Crea una versión optimizada de handleDetailsVisibility con 250ms de delay
const debouncedHandleDetails = debounce(handleDetailsVisibility, 250);

// Ejecuta la función cuando:
// 1. La página termina de cargar, para establecer el estado inicial
// 2. La ventana cambia de tamaño, usando la versión con debounce
window.addEventListener('load', handleDetailsVisibility);
window.addEventListener('resize', debouncedHandleDetails);

















// Función que maneja el reposicionamiento del elemento social
function handleSocialPosition() {
  // Seleccionar los elementos necesarios
  const socialElement = document.querySelector('.c-social');
  const complaintsElement = document.querySelector('.c-custom-footer__complaints');
  const containerElement = document.querySelector('.c-custom-footer__container');
  
  // Verificar si estamos en desktop (>= 1025px)
  const isDesktop = window.innerWidth >= 1025;

  if (isDesktop && socialElement && complaintsElement) {
    // En desktop: mover social dentro de complaints
    complaintsElement.appendChild(socialElement);
  } else if (socialElement && containerElement) {
    // En mobile: devolver social a su posición original (inicio del container)
    containerElement.insertBefore(socialElement, containerElement.firstChild);
  }
}

// Implementación de debounce para optimizar el rendimiento
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Versión optimizada de la función con debounce
const debouncedHandleSocial = debounce(handleSocialPosition, 250);

// Event listeners
document.addEventListener('DOMContentLoaded', handleSocialPosition);
window.addEventListener('resize', debouncedHandleSocial);























// Mide la barra de anuncio y publica su alto en --ens-ann-h.
// enova.css la fija arriba y apoya en esta variable el `top` del header y el
// espacio que .m-header reserva. Se mide en vez de hardcodear 34px para que
// siga cuadrando si cambia el tamaño de fuente, si el texto envuelve en dos
// líneas, o si el merchant apaga la barra desde el editor (entonces vale 0).
function updateAnnouncementHeight() {
  const bar = document.querySelector('.shopify-section-group-header-group[id$="__annoucement"]');
  const height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
  document.documentElement.style.setProperty('--ens-ann-h', height + 'px');
}

const debouncedAnnouncementHeight = debounce(updateAnnouncementHeight, 150);

updateAnnouncementHeight();
document.addEventListener('DOMContentLoaded', updateAnnouncementHeight);
window.addEventListener('load', updateAnnouncementHeight);
window.addEventListener('resize', debouncedAnnouncementHeight);

// La barra rota mensajes de distinto largo: si alguno envuelve, el alto cambia.
if (window.ResizeObserver) {
  const bar = document.querySelector('.shopify-section-group-header-group[id$="__annoucement"]');
  if (bar) new ResizeObserver(debouncedAnnouncementHeight).observe(bar);
}
